import { Backdrop, CircularProgress } from "@mui/material";
import React from "react";

export default function LoadingBackdrop(props) {
  const { loading, children, className } = props;

  return (
    (<div className={className}>
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
          backdropFilter: "blur(5px)",
        }}
        open={loading}
      >
        <CircularProgress color='inherit' />
      </Backdrop>
      {children}
    </div>)
  );
}
